export enum TabIndex {
  REMOVED = -1, // Remove element from natural order
  ZERO = 0 // Inserts element into natural tab order
}
